<header class="mobile-header" role="banner">
  <img
    (error)="logoSrc = fallbackLogoPath"
    [src]="logoSrc"
    alt="Afirma"
    [style.height]="logoHeight"
    [style.width]="logoWidth"
    class="logo"
  />
  <button
    class="hamburger"
    type="button"
    aria-label="Abrir menú"
    aria-controls="app-sidenav"
    [attr.aria-expanded]="nav.isOpen()"
    (click)="nav.toggle()"
  >
    <span [innerHTML]="safeIcon(AppIcons.BURGER_MENU_BG)" aria-hidden="true" class="icon-bg"></span>
    <span [innerHTML]="safeIcon(AppIcons.BURGER_MENU_BARS)" aria-hidden="true" class="icon-bars"></span>
  </button>
</header>
